// Sentry must be imported first
import "./lib/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { logger } from "./lib/logger";

// Global error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logger.error(String(message), {
    stack: error?.stack,
    metadata: { source, lineno, colno, type: "window.onerror" },
  });
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  const reason = event.reason;
  logger.error(reason?.message || String(reason), {
    stack: reason?.stack,
    metadata: { type: "unhandledrejection" },
  });
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
